import React from 'react';
import './css/CircularProgressBlock.css';
import { AChart } from './aChart';
import {
  AiOutlineLeft,
  AiOutlineRight
} from 'react-icons/ai';
import { formatNumberWithCommas } from './formatIntegerWithCommas.js';
import { t } from 'ttag';

function TotalRoundsBlock({ round, price_bif, price_now, price_after }) {

  return (
    <div className="circular-progress-block">
      <div className="circular-progress-header">{t`Total rounds 100`}</div>
      <AChart series={[round]} seriest={["100"]} labels={[t`Round`]} />

      <div className="token-price-curr">{t`Token price`}</div>

      <div className="token-price">
        <div>
          <div>
            {formatNumberWithCommas(price_bif, 3)}
          </div>
          <div className="token-price-curr">
            USDT
          </div>
        </div>
        <AiOutlineRight />
        <div style={{ color: "#6ddf66" }}>
          <div style={{ fontSize: "1.3em", color: "#6ddf66" }}>
            {formatNumberWithCommas(price_now, 3)}
          </div>
          <div style={{ color: "#6ddf66" }} className="token-price-curr">
            USDT
          </div>
        </div>
        <AiOutlineRight />
        <div>
          <div>
            {formatNumberWithCommas(price_after, 3)}
          </div>
          <div className="token-price-curr">
            USDT
          </div>
        </div>
      </div>

    </div>
  );
}

export { TotalRoundsBlock };